import { render, staticRenderFns } from "./TextQuiz.vue?vue&type=template&id=ab840990"
import script from "./TextQuiz.vue?vue&type=script&lang=js"
export * from "./TextQuiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports